import { Component, Inject } from '@angular/core';
import { DashboardService } from 'src/app/dashboard/dashboard.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
    selector: 'app-regenerate-question-dialog',
    templateUrl: './regenerate-question-dialog.component.html',
    styleUrls: ['./regenerate-question-dialog.component.scss']
})
export class RegenerateQuestionDialogComponent {

    title = 'Regenerate Question';
    description = 'We will generate a fresh question using the current one as context. You can optionally add hints to guide the regeneration.';

    instructions: string[] = [];
    newInstruction = '';
    max = 8;

    commonPrompts: { promptText: string }[] = [];

    constructor(
        public dialogRef: MatDialogRef<RegenerateQuestionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dashboardService: DashboardService,
    ) {
        this.title = data?.title || this.title;
        this.description = data?.description || this.description;
        this.commonPrompts = Array.isArray(data?.commonPrompts) ? data.commonPrompts : [];
        if (Array.isArray(data?.prefill)) {
            this.instructions = [...data.prefill];
        }
        // If not present in cache and no prompts passed, fetch directly from backend base /api
        if ((!this.commonPrompts || this.commonPrompts.length === 0) && data?.appliesTo) {
            this.dashboardService.getPromptHints({ appliesTo: data.appliesTo, category: 'HINT' })
                .subscribe({
                    next: (res: any) => { this.commonPrompts = res?.data || []; },
                    error: () => { /* ignore */ }
                });
        }
    }

    addInstruction(): void {
        const text = (this.newInstruction || '').trim();
        if (!text) return;
        if (this.instructions.includes(text)) { this.newInstruction = ''; return; }
        if (this.instructions.length >= this.max) { return; }
        this.instructions = [text, ...this.instructions];
        this.newInstruction = '';
    }

    removeInstruction(i: number): void {
        this.instructions.splice(i, 1);
    }

    addSuggestion(text: string): void {
        if (!text) return;
        this.newInstruction = text;
        this.addInstruction();
    }

    clearInstructions(): void {
        this.instructions = [];
    }

    isSelected(text: string): boolean {
        return (this.instructions || []).includes((text || '').trim());
    }

    onPrimaryRegenerate(): void {
        if (this.instructions && this.instructions.length) {
            this.dialogRef.close({ additionalPrompts: this.instructions });
        } else {
            this.dialogRef.close('confirm');
        }
    }
}


